import type { CdwColDef } from '../interfaces/cdw-col-def.interface';

export const previewColumn: CdwColDef = {
  colId: 'previewIconComponent', // Explicitly set colId to match cellRenderer
  headerName: 'View',
  // 70px (was 50) so "View" fits without truncation under alpine theme
  // — alpine's larger header font + cell padding overflows the original
  // 50px width and ellipsizes the label to "V.".
  width: 70,
  pinned: 'left',
  cellRenderer: 'previewIconComponent',
  cellClass: 'ag-cell-center',
  headerClass: 'ag-header-center preview-column-header',
  resizable: false,
  // System column: never user-draggable, and locked to the far left so no
  // other column can be dragged into its slot and a persisted column-layout
  // restore (applyColumnState) cannot reorder it.
  suppressMovable: true,
  lockPosition: 'left',
  suppressMenu: true,
  suppressColumnsToolPanel: true,
  lockVisible: true,
};
